<template>
  <div>
    <div v-if="showIndex">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">
            VDCI's Great Web Mechanism Reports
          </h1>
          <sites-loading-progress></sites-loading-progress>
        </div>
      </div>
      <div class="panel">
        <div class="panel-heading"></div>

        <loading :working="loading"></loading>

        <div class="panel-body data-dash" v-if="!loading">
          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <h2>Adult Surveillance:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-adult-surveillance' }"
                  ><i class="fa fa-file-pdf-o"></i> Adult Mosquito Surveillance
                  Data</router-link
                >
                <br />
                <router-link :to="{ name: 'report-cmc-weekly-trap' }"
                  ><i class="fa fa-file-pdf-o"></i> Trap Data - Details
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-ot-surveillance' }"
                  ><i class="fa fa-file-pdf-o"></i> Mosquito Surveillance –
                  Table Format</router-link
                >
                <br />
                <router-link :to="{ name: 'report-cmc-trap-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> Trap Data - Summary
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-cmc-season-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> All Traps - Composite
                  Report</router-link
                >
                <br />
                <router-link
                  :to="{ name: 'report-mosquito-surveillance-graph-1' }"
                  ><i class="fa fa-file-pdf-o"></i> Surveillance Graph All
                  Combined</router-link
                >
                <br />
                <router-link
                  :to="{ name: 'report-mosquito-surveillance-graph-2' }"
                  ><i class="fa fa-file-pdf-o"></i> Surveillance Graph with
                  Species Breakdown</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-new-jersey-light-trap' }"
                  ><i class="fa fa-file-pdf-o"></i> New Jersey Light Trap
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-ovi-trap' }"
                  ><i class="fa fa-file-pdf-o"></i> Ovi Trap Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-gravid-trap' }"
                  ><i class="fa fa-file-pdf-o"></i> Gravid Trap
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-gravid-highs' }"
                  ><i class="fa fa-file-pdf-o"></i> Gravid Highs
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-gravid-recap' }"
                  ><i class="fa fa-file-pdf-o"></i> Gravid Recap
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-light-female-trap' }"
                  ><i class="fa fa-file-pdf-o"></i> Light Female Trap
                  Report</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-export-trap-dates' }"
                  ><i class="fa fa-file-excel-o"></i> Trap Data
                  Export</router-link
                >
              </div>

              <h2>Arboviral Surveillance:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-arboviral-surveillance' }"
                  ><i class="fa fa-file-pdf-o"></i> Arboviral Surveillance
                  Results</router-link
                >
                <br />
                <router-link :to="{ name: 'report-arbo-web-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> WNV Positive
                  Pools</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-adult-sample-pool' }"
                  ><i class="fa fa-file-pdf-o"></i> Arboviral Data
                  Export</router-link
                >
                <br />
                <router-link :to="{ name: 'report-boulder-lab-submissions' }"
                  ><i class="fa fa-file-excel-o"></i> Arboviral Lab Submissions
                  Export</router-link
                >
              </div>

              <h2>Adulticide Applications:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-ground-adulticide' }"
                  ><i class="fa fa-file-pdf-o"></i> Ground Adulticide
                  Applications</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-export-spray-dates' }"
                  ><i class="fa fa-file-excel-o"></i> Adulticide Data
                  Export</router-link
                >
              </div>

              <h2>Landing Rates:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-landing-rate' }"
                  ><i class="fa fa-file-pdf-o"></i> Landing Rate
                  Data</router-link
                >
              </div>
            </div>

            <div class="col-xs-12 col-sm-6">
              <h2>Larval Surveillance:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-larval-surveillance' }"
                  ><i class="fa fa-file-pdf-o"></i> Larval Surveillance
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-kill-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> Larval Site Data
                  Summary</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-larvicide' }"
                  ><i class="fa fa-file-pdf-o"></i>Larvicide Report</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-route-book-sheets' }"
                  ><i class="fa fa-file-pdf-o"></i> Site Route Book
                  Sheets</router-link
                >
                <br />
                <router-link :to="{ name: 'report-boco-inspections' }"
                  ><i class="fa fa-file-excel-o"></i> Basic Surveillance Data
                  Export</router-link
                >
              </div>

              <h2>Larvicide Applications:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-larvicide-applications' }"
                  ><i class="fa fa-file-pdf-o"></i> Larvicide
                  Applications</router-link
                >
                <br />
                <router-link :to="{ name: 'report-catch-basin' }"
                  ><i class="fa fa-file-pdf-o"></i> Catch Basin Treatment
                  Report</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-export-larvicide-dates' }"
                  ><i class="fa fa-file-excel-o"></i> Larvicide Data
                  Export</router-link
                >
                <br />
                <router-link :to="{ name: 'report-boco-treatments' }"
                  ><i class="fa fa-file-excel-o"></i> CoB Larval
                  Monitoring</router-link
                >
                <br />
                <router-link :to="{ name: 'report-denver-larvicide-dates' }"
                  ><i class="fa fa-file-excel-o"></i> Larvicide Formatted
                  Export</router-link
                >
              </div>

              <h2>Program Summary:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-ot-weekly-program-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> Weekly Program
                  Summary</router-link
                >
                <br />
                <router-link :to="{ name: 'report-ot-larval' }"
                  ><i class="fa fa-file-pdf-o"></i> CoB Surveillance & Control
                  Summary</router-link
                >
                <br />
                <router-link :to="{ name: 'report-mcs-activity-recap' }"
                  ><i class="fa fa-file-pdf-o"></i>Activity Recap</router-link
                >
                <br />
                <router-link :to="{ name: 'report-spray-zone-recap' }"
                  ><i class="fa fa-file-pdf-o"></i> Spray Zone Recap
                </router-link>
              </div>

              <h2>Service Calls:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-service-requests-summary' }"
                  ><i class="fa fa-file-pdf-o"></i> Service Requests
                  Summary</router-link
                >
                <br />
                <router-link :to="{ name: 'report-service-requests' }"
                  ><i class="fa fa-file-pdf-o"></i> Service Request
                  Report</router-link
                >
                <br />
                <router-link :to="{ name: 'report-call-shutoff' }"
                  ><i class="fa fa-file-pdf-o"></i> Shutoffs/Notifications
                  List</router-link
                >
                <br />
                <br />
                <router-link :to="{ name: 'report-export-no-spray' }"
                  ><i class="fa fa-file-excel-o"></i> Shutoffs/Notifications
                  Export</router-link
                >
                <br />
                <router-link :to="{ name: 'report-export-hot-line' }"
                  ><i class="fa fa-file-excel-o"></i> Export Hot
                  Line</router-link
                >
              </div>

              <h2>Raw Export:</h2>
              <div class="report-section">
                <router-link :to="{ name: 'report-raw-export' }"
                  ><i class="fa fa-file-archive-o"></i> Raw Export of ALL
                  Data</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import loading from "@/components/loading";
import loader from "../../utils/loader";
import sitesLoadingProgress from "@/components/report/sites_loading_progress";

export default {
  name: "report",

  components: {
    loading,
    sitesLoadingProgress,
  },

  computed: {
    showIndex() {
      return this.$route.path === "/report";
    },
    loading() {
      return !this.$store.getters.allNonSitesDataLoaded;
    },
  },

  mounted() {
    loader.lookups().then(() => null);
  },
};
</script>

<style lang="scss">
.report-section {
  margin-left: 20px;
}
h2 {
  margin-top: 40px;
}
</style>
